import { ApiPath } from '@/common/app/api-path';
import {
  type SellResource,
  type SellResourceBody,
} from '@/common/types/storageType';

import { api } from '../base';

const storageApi = api.injectEndpoints({
  endpoints: (builder) => ({
    sellStorageItem: builder.mutation<SellResource, SellResourceBody[]>({
      query: (body) => ({
        url: ApiPath.STORAGE_SELL,
        method: 'POST',
        body,
      }),
    }),
    sellAllStorageItems: builder.mutation<SellResource, void>({
      query: () => ({
        url: ApiPath.STORAGE_SELL_ALL,
        method: 'POST',
      }),
    }),
  }),
});

const { useSellStorageItemMutation, useSellAllStorageItemsMutation } =
  storageApi;

export {
  storageApi,
  useSellAllStorageItemsMutation,
  useSellStorageItemMutation,
};
